<template>
  <div class="border-left pl-2">
    <CRow>
      <CCol sm="12">
        <CInput
          :label="label_overrides && label_overrides.street_address ? label_overrides.street_address : 'Street Address'"
          placeholder=""
          v-model="form.street_address"
          :horizontal="true"
          :addLabelClasses="['font-weight-bold']"
          required
        />
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="12">
        <CInput
          :label="label_overrides && label_overrides.city ? label_overrides.city : 'City'"
          placeholder=""
          v-model="form.city"
          :horizontal="true"
          :addLabelClasses="['font-weight-bold']"
          required
        />
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="12">
        <CInput
          :label="label_overrides && label_overrides.region ? label_overrides.region : 'Province/State'"
          placeholder=""
          v-model="form.region"
          :horizontal="true"
          :addLabelClasses="['font-weight-bold']"
          required
        />
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="12">
        <CInput
          :label="label_overrides && label_overrides.country ? label_overrides.country : 'Country'"
          placeholder=""
          v-model="form.country"
          :horizontal="true"
          :addLabelClasses="['font-weight-bold']"
          required
        />
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="12">
        <CInput
          :label="label_overrides && label_overrides.postal ? label_overrides.postal : 'Postal/Zip'"
          placeholder=""
          v-model="form.postal"
          :horizontal="true"
          :addLabelClasses="['font-weight-bold']"
          required
        />
      </CCol>
    </CRow>
    <CRow v-if="commit">
      <CCol sm="7"></CCol>
      <CCol sm="5">
        <CButtonGroup class="w-100">
          <CButton v-if="!hide_cancel" @click="$emit('cancel')" color="default" class="btn-square">Cancel</CButton>
          <CButton class="btn-sf btn-square" @click="save">Save</CButton>
        </CButtonGroup>
      </CCol>
    </CRow>
  </div>
</template>

<script>
  import Location from "../../../models/Location"
  import CustomerLocation from "../../../models/CustomerLocation";

  export default {
  name: 'LocationEditForm',
  data() {
    return {
      form: {
        street_address: null,
        city: null,
        region: null,
        country: null,
        postal: null
      }
    };
  },
  props: {
    location: {
      type: Object,
      default: null
    },
    commit: {
      type: Boolean,
      default: true
    },
    label_overrides: {
      type: Object,
      default: null
    },
    hide_cancel: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    getPayload() {
      let payload = JSON.parse(JSON.stringify(this.form));
      let temp = Object.values(JSON.parse(JSON.stringify(payload)));
      payload.address = temp.filter(x => x).join(', ');
      return payload;
    },
    save() {
      if(this.commit) {
        return;
      }
      this.createLocation().then((location) => {
        this.$emit('onSave', location);
        let customer_location = CustomerLocation.query().where('location_id', location.id).first();
        if(customer_location) {
          CustomerLocation.api().export(customer_location.id);
        }
      });
    },
    createLocation: function() {
      return Location.api().update(this.location.id, this.getPayload()).then((response) => {
        return response.entities.locations[0];
      });
    },
  },
  watch: {
    form: {
      handler: function() {
        this.$emit('change', this.getPayload());
      },
      deep: true
    },
    location: {
      handler: function() {
        for(let k in this.form) {
          if(this.location) {
            this.form[k] = this.location[k];
          }
        }
      },
      deep: true
    },
  },
  mounted() {
    for(let k in this.form) {
      if(this.location) {
        this.form[k] = this.location[k];
      }
    }
  }
}
</script>
